"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _get = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnchorsElement = void 0;

var Point2D_1 = require("../../Core/Point2D");

var IRegionCallbacks_1 = require("../../Interface/IRegionCallbacks");

var AnchorsComponent_1 = require("../Component/AnchorsComponent");
/**
 * `AnchorsComponent` for the `PolylineRegion` class.
 */


var AnchorsElement = /*#__PURE__*/function (_AnchorsComponent_1$A) {
  _inherits(AnchorsElement, _AnchorsComponent_1$A);

  /**
   * Creates a new `AnchorsElement` object.
   * @param paper - The `Snap.Paper` object to draw on.
   * @param paperRect - The parent bounding box for created component.
   * @param regionData - The `RegionData` object shared across components. Used also for initial setup.
   * @param callbacks - The external callbacks collection.
   */
  function AnchorsElement(paper) {
    var _this;

    var paperRect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var regionData = arguments.length > 2 ? arguments[2] : undefined;
    var callbacks = arguments.length > 3 ? arguments[3] : undefined;

    _classCallCheck(this, AnchorsElement);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AnchorsElement).call(this, paper, paperRect, regionData, callbacks));
    /**
     * Internal flag to delete a point on pointer up event.
     */

    _this.deleteOnPointerUp = false;
    /**
     * Internal flat to add a point on pointer up event.
     */

    _this.addOnPointerUp = false;
    _this.anchorsLength = regionData.points.length;
    return _this;
  }
  /**
   * Redraws the componnent.
   */


  _createClass(AnchorsElement, [{
    key: "redraw",
    value: function redraw() {
      var _this2 = this;

      if (this.regionData.points !== null && this.regionData.points.length > 0) {
        var points = this.regionData.points; // rebuild anchors

        if (this.anchorsLength !== points.length) {
          window.requestAnimationFrame(function () {
            _this2.anchors.forEach(function (anchor) {
              anchor.remove();
            });

            _this2.anchors = [];

            _this2.buildPointAnchors();
          });
          this.anchorsLength = points.length;
        } else {
          window.requestAnimationFrame(function () {
            _this2.regionData.points.forEach(function (p, index) {
              _this2.anchors[index].attr({
                cx: p.x,
                cy: p.y
              });
            });
          });
        }

        var pointsData = [];
        this.regionData.points.forEach(function (p) {
          pointsData.push(p.x, p.y);
        });
        this.anchorsPolyline.attr({
          points: pointsData.toString()
        });
      }
    }
    /**
     * Creates a collection on anchors.
     */

  }, {
    key: "buildAnchors",
    value: function buildAnchors() {
      this.buildPolylineAnchors();

      _get(_getPrototypeOf(AnchorsElement.prototype), "buildAnchors", this).call(this);
    }
    /**
     * Creates acollection of anchor points.
     */

  }, {
    key: "buildPolylineAnchors",
    value: function buildPolylineAnchors() {
      var pointsData = [];
      this.regionData.points.forEach(function (p) {
        pointsData.push(p.x, p.y);
      });
      this.anchorsPolyline = this.paper.polyline(pointsData);
      this.anchorsPolyline.addClass("anchorLineStyle");
      this.subscribeLineToEvents(this.anchorsPolyline);
      this.anchorsNode.add(this.anchorsPolyline);
    }
    /**
     * Subscribe an anchor to events.
     * @param anchor - The anchor to wire up with events.
     */

  }, {
    key: "subscribeLineToEvents",
    value: function subscribeLineToEvents(anchor) {
      var _this3 = this;

      this.subscribeToEvents([{
        base: anchor.node,
        event: "pointermove",
        listener: function listener(e) {
          if (e.ctrlKey) {
            _this3.activeAnchorIndex = -1;

            var anchorPoint = _this3.getActiveAnchorPoint(e);

            _this3.dragOrigin = anchorPoint;
            _this3.addOnPointerUp = true;
            window.requestAnimationFrame(function () {
              _this3.ghostAnchor.attr({
                cx: anchorPoint.x,
                cy: anchorPoint.y,
                display: "block"
              });
            });
          } else {
            _this3.addOnPointerUp = false;
          }
        },
        bypass: false
      }]);
    }
    /**
     * Updated the `regionData` based on the new ghost anchor location. Should be redefined in child classes.
     * @param p - The new ghost anchor location.
     */

  }, {
    key: "updateRegion",
    value: function updateRegion(p) {
      var rd = this.regionData.copy();

      if (this.activeAnchorIndex >= 0 && this.activeAnchorIndex <= this.regionData.points.length) {
        rd.setPoint(p, this.activeAnchorIndex - 1);
      }

      this.callbacks.onChange(this, rd, IRegionCallbacks_1.ChangeEventType.MOVING);
    }
    /**
     * Callback for the pointerenter event for the ghost anchor.
     * @param e - PointerEvent object.
     */

  }, {
    key: "onGhostPointerEnter",
    value: function onGhostPointerEnter(e) {
      if (e.ctrlKey) {
        if (this.addOnPointerUp && this.activeAnchorIndex < 0) {
          this.ghostAnchor.addClass("add");
        } else if (this.regionData.points.length > 2) {
          this.ghostAnchor.addClass("delete");
          this.deleteOnPointerUp = true;
          this.addOnPointerUp = false;
        }
      } else {
        this.ghostAnchor.removeClass("delete");
        this.ghostAnchor.removeClass("add");
        this.deleteOnPointerUp = false;
      }

      _get(_getPrototypeOf(AnchorsElement.prototype), "onGhostPointerEnter", this).call(this, e);
    }
    /**
     * Callback for the pointermove event for the ghost anchor.
     * @param e - PointerEvent object.
     */

  }, {
    key: "onGhostPointerMove",
    value: function onGhostPointerMove(e) {
      if (e.ctrlKey && this.activeAnchorIndex !== 0) {
        var p = this.getActiveAnchorPoint(e);
        var dist = Number.MAX_VALUE;
        var index = -1;
        this.regionData.points.forEach(function (point, i) {
          var d = p.squareDistanceToPoint(point);

          if (d < dist) {
            dist = d;
            index = i;
          }
        });
        var swapToDelete = dist < AnchorsElement.ANCHOR_POINT_LINE_SWITCH_THRESHOLD;

        if (this.addOnPointerUp && this.activeAnchorIndex < 0 && !swapToDelete) {
          this.ghostAnchor.addClass("add");
          this.activeAnchorIndex = -1;
        } else if (this.regionData.points.length > 2 || swapToDelete) {
          this.ghostAnchor.removeClass("add");
          this.ghostAnchor.addClass("delete");
          this.activeAnchorIndex = index + 1;
          this.deleteOnPointerUp = true;
          this.addOnPointerUp = false;
        }
      } else {
        this.ghostAnchor.removeClass("delete");
        this.ghostAnchor.removeClass("add");
        this.deleteOnPointerUp = false;
        this.addOnPointerUp = false;
      }

      _get(_getPrototypeOf(AnchorsElement.prototype), "onGhostPointerMove", this).call(this, e);
    }
    /**
     * Callback for the pointerup event for the ghost anchor.
     * @param e - PointerEvent object.
     */

  }, {
    key: "onGhostPointerUp",
    value: function onGhostPointerUp(e) {
      var rd = this.regionData.copy();

      if (this.deleteOnPointerUp) {
        if (this.activeAnchorIndex > 0 && this.activeAnchorIndex <= this.regionData.points.length) {
          var points = rd.points;
          points.splice(this.activeAnchorIndex - 1, 1);
          rd.setPoints(points);
        }

        this.deleteOnPointerUp = false;
        this.addOnPointerUp = false;
        this.ghostAnchor.removeClass("delete");
        this.ghostAnchor.removeClass("add");
        this.callbacks.onChange(this, rd, IRegionCallbacks_1.ChangeEventType.MOVEEND);
      } else if (this.addOnPointerUp) {
        var offsetX = e.clientX - e.target.closest("svg").getBoundingClientRect().left;
        var offsetY = e.clientY - e.target.closest("svg").getBoundingClientRect().top;
        var point = new Point2D_1.Point2D(offsetX, offsetY);
        var _points = rd.points; // Find the nearest segment of polyline

        var index = 0;
        var distance = Number.MAX_VALUE;

        for (var i = 0; i < _points.length - 1; i++) {
          var d = this.dragOrigin.squareDistanceToLine(_points[i], _points[i + 1]);

          if (d < distance) {
            index = i;
            distance = d;
          }
        }

        _points.splice(index + 1, 0, point);

        rd.setPoints(_points);
        this.deleteOnPointerUp = false;
        this.addOnPointerUp = false;
        this.ghostAnchor.addClass("delete");
        this.callbacks.onChange(this, rd, IRegionCallbacks_1.ChangeEventType.MOVEEND);
      }

      _get(_getPrototypeOf(AnchorsElement.prototype), "onGhostPointerUp", this).call(this, e);
    }
    /**
     * Returns `Point2D` with coordinates of active anchor
     */

  }, {
    key: "getActiveAnchorPoint",
    value: function getActiveAnchorPoint(e) {
      if (this.activeAnchorIndex > 0) {
        return this.regionData.points[this.activeAnchorIndex - 1];
      } else if (this.activeAnchorIndex < 0) {
        var offsetX = e.clientX - e.target.closest("svg").getBoundingClientRect().left;
        var offsetY = e.clientY - e.target.closest("svg").getBoundingClientRect().top;
        return new Point2D_1.Point2D(offsetX, offsetY);
      } else {
        return null;
      }
    }
  }]);

  return AnchorsElement;
}(AnchorsComponent_1.AnchorsComponent);

exports.AnchorsElement = AnchorsElement;
/**
 * Default threshold distance to define whether ctrl-pointer click is on point or line.
 */

AnchorsElement.ANCHOR_POINT_LINE_SWITCH_THRESHOLD = 5;